document.addEventListener('DOMContentLoaded', function () {
  function setVideoMuteState(button, muted) {
    const container = button.closest('[data-video-mute-container], .banner-section');
    if (!container) return;

    button.dataset.muted = muted ? 'true' : 'false';
    button.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
    button.querySelector('.banner-mute-icon--off').classList.toggle('show', muted);
    button.querySelector('.banner-mute-icon--on').classList.toggle('show', !muted);

    container.querySelectorAll('video').forEach(function (video) {
      if (isVideoVisible(video)) {
        video.muted = muted;
        if (!muted && video.paused) {
          video.play().catch(function () {});
        }
      }
    });

    window.syncResponsiveVideos(container);
  }

  function isVideoVisible(video) {
    return window.getComputedStyle(video).display !== 'none' && video.getClientRects().length > 0;
  }

  document.querySelectorAll('[data-banner-mute]').forEach(function (button) {
    button.addEventListener('click', function () {
      const isMuted = button.dataset.muted !== 'false';
      setVideoMuteState(button, !isMuted);
    });
  });

  document.querySelectorAll('[data-video-mute-container]').forEach(function (container) {
    const button = container.querySelector('[data-banner-mute]');
    if (!button) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && button.dataset.muted === 'false') {
          setVideoMuteState(button, true);
        }
      });
    }, { threshold: 0 });

    observer.observe(container);
  });

  window.syncResponsiveVideos();

  document.querySelectorAll('[data-banner-loader]').forEach(function (loader) {
    const container = loader.closest('[data-video-mute-container], .banner-section');
    if (!container) return;

    const videos = container.querySelectorAll('video');
    if (!videos.length) {
      loader.classList.add('is-hidden');
      return;
    }

    const hideLoader = function () {
      loader.classList.add('is-hidden');
    };

    videos.forEach(function (video) {
      if (video.readyState >= 3) {
        hideLoader();
        return;
      }

      video.addEventListener('loadeddata', hideLoader, { once: true });
      video.addEventListener('canplay', hideLoader, { once: true });
      video.addEventListener('playing', hideLoader, { once: true });
      video.addEventListener('error', hideLoader, { once: true });
    });
  });
});
